export default "__VITE_ASSET__B7lA5Y96__"